import arrayChunk from "astrid-helpers/src/arrayChunk";

import getCollectionData from "../../utils/getCollectionData";
import runTransaction from "../../utils/runTransaction";

import distributionStatuses from "./constants/distributionStatuses";

export default async function clearScheduledDistributions(
	firebase,
	{ article, channelIds = [] },
	{ transaction } = {},
) {
	if (channelIds.length === 0) {
		return;
	}

	const distributions = (
		await Promise.all(
			arrayChunk(channelIds, 10).map(async (chunk) => {
				return getCollectionData(
					firebase
						.firestore()
						.collection("distributions")
						.where("article.ref", "==", article.ref)
						.where("channel.id", "in", chunk)
						.where("status", "==", distributionStatuses.SCHEDULED),
				);
			}),
		)
	).flat();

	if (distributions.length === 0) {
		return;
	}

	return runTransaction(
		firebase,
		[],
		(transaction, []) => {
			for (const { ref } of distributions) {
				transaction.delete(ref);
			}
		},
		transaction,
	);
}
